import React, { useState, useEffect, useContext, useRef } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { dashboardStyles } from "../../Admin/dashboard/DashboardWrapper.css.js";
import { Toast } from "primereact/toast";
import { UserDashboardSkeleton } from "../../../Components";
import UserDashboardHeader from "./components/UserDashboardHeader";
import UserDashboardSidebar from "./components/UserDashboardSidebar";
import UserDashboardStatus from "./components/UserDashboardStatus";
import axios from "axios";
import { url, api } from "../../../env";

export default function UserDashboardView() {
    const { authInfo } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [dashboardData, setDashboardData] = useState(null);
    const toast = useRef(null);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${url}/user-dashboard`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    Accept: "application/json"
                }
            });
            if (response.data.success) {
                const data = response.data.data;
                if (data.financial_details && typeof data.financial_details === 'string') {
                    try {
                        data.financial_details = JSON.parse(data.financial_details);
                    } catch (e) {
                        console.error('Error parsing financial_details:', e);
                    }
                }
                setDashboardData(data);
            }
        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "No se pudo cargar la información del dashboard",
                life: 3000
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!authInfo.loading && !authInfo.token) {
            window.location.href = '/login';
            return;
        }
        if (authInfo.token) {
            fetchDashboardData();
        }
    }, [authInfo.token, authInfo.loading]);

    if (loading && !dashboardData) return <UserDashboardSkeleton />;

    return (
        <div className="min-h-screen p-3 md:p-4 dashboard-container" css={dashboardStyles()}>
            <Toast ref={toast} />
            <div className="mx-auto" style={{ maxWidth: "1500px" }}>
                <UserDashboardHeader user={dashboardData?.user} car={dashboardData?.vehicle} />

                <div className="flex flex-column md:flex-row gap-2 md:gap-3 lg:gap-4 mt-3">
                    <UserDashboardSidebar
                        user={dashboardData?.user}
                        car={dashboardData?.vehicle}
                        onPhotoUpdate={fetchDashboardData}
                        toast={toast}
                    />

                    <div className="dashboard-main-content">
                        <UserDashboardStatus
                            process={dashboardData?.process}
                            financialDetails={dashboardData?.financial_details}
                            onUpdate={fetchDashboardData}
                            toast={toast}
                            status={dashboardData?.status}
                            message={dashboardData?.message}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
